<template>
  <div class="leaderboard" style="overflow-y: scroll" v-bind:style="leaderboardheight">
    <div v-if="!isAthleteLoaded" class="spinner">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
    <div v-else>
      <div v-if="athlete.race_id == '802'" class="tw-mx-4">
        <img v-if="athlete.team_id && athlete.team.athletes[0].club.length > 0" v-bind:src="athlete.team.athletes[0].club"  />
        <img v-if="!athlete.team_id && athlete.club.length > 0" v-bind:src="athlete.club" />
      </div>
      <progressbar v-if="!athlete.isFinished && raceType == 'App\\Tracking\\Route'" v-bind:current-distance="athlete.properties.distance" v-bind:total-distance="raceDist" />
      <table v-if="athlete.team_id">
        <tbody id="leaderbody1">
        <tr v-for="member in athlete.team.athletes">
          <td style="padding-left: 30px;"><span class="">{{member.bib_id}}</span></td>
          <td>{{member.first_name}} {{member.last_name}}</td>
        </tr>
        </tbody>
      </table>
      <athleteFinished v-if="athlete.isFinished"></athleteFinished>
      <infoblock></infoblock>
      <athleteShare></athleteShare>
      <athletecptable></athletecptable>
      <div class="person_cp_table_holder">
        <span style="padding-bottom: 10px;">
        <a :href="'https://app.sportraxs.com/api/tracking/athletes/' + athlete.id + '/gpx'" target="_blank" style="cursor: pointer;" class="withdrawn">
          Download GPX
        </a>
      </span>
      </div>
    </div>
  </div>
</template>
<style>
  .spinner {
    width: 40px;
    height: 40px;

    position: relative;
    margin: 100px auto;
  }

  .double-bounce1, .double-bounce2 {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #fff;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;

    -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
    animation: sk-bounce 2.0s infinite ease-in-out;
  }

  .double-bounce2 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
  }

  @-webkit-keyframes sk-bounce {
    0%, 100% { -webkit-transform: scale(0.0) }
    50% { -webkit-transform: scale(1.0) }
  }

  @keyframes sk-bounce {
    0%, 100% {
      transform: scale(0.0);
      -webkit-transform: scale(0.0);
    } 50% {
        transform: scale(1.0);
        -webkit-transform: scale(1.0);
      }
  }
</style>
<script>
import { mapGetters } from 'vuex'
import progressbar from './progressbar'
import infoblock from './infoblock.vue'
import athletecptable from './athletecptablevue.vue'
import athleteFinished from './athleteFinished.vue'
import athleteShare from './athleteShare.vue'
import favIcon from '../favicon'

export default{
  data: function () {
    return {
    }
  },
  watch: {
    '$route': function (to, from) {
    }
  },
  components: {
    favIcon,
    progressbar,
    infoblock,
    athletecptable,
    athleteFinished,
    athleteShare
  },
  computed: {
    ...mapGetters({
      raceType: 'raceType',
      raceDist: 'routeDistance',
      athlete: 'focusedAthlete',
      getAthletes: 'athletes',
      ath: 'athlete'
    }),
    leaderboardheight: function () {
      if (this.mobile) {
        let h = window.innerHeight - 70 - 50 - 60
        return {
          height: h + 'px'
        }
      } else {
        let h = window.innerHeight - 70 - 50 - 53
        return {
          height: h + 'px'
        }
      }
    },
    isAthleteLoaded: function() {
      return Object.keys(this.ath).length !== 0
    }
  },
  created: function () {
    // TODO Matthew - for now as race might not be loaded if directly routed too.
    if (this.getAthletes.length === 0) {
      if (this.mobile) {
        this.$router.push({ name: 'mleaderboard' })
      } else {
        this.$router.push({ name: 'leaderboard' })
      }
    } else {
      this.$store.dispatch('focusAthlete', this.$router.currentRoute.params.id)
    }
    this.$store.dispatch('loadRaceAthlete', this.$router.currentRoute.params.id)
  },
  beforeRouteUpdate (to, from, next) {
    this.$store.dispatch('removeRaceAthlete')
    this.$store.dispatch('loadRaceAthlete', to.params.id)
    next()
  },
  beforeDestroy: function() {
    this.$store.dispatch('removeRaceAthlete')
  },
  methods: {
    distance: function (ath) {
      if (ath.status == null) {
        return (ath.distance / 1000.0).toFixed(1) + ' km'
      } else {
        return '-'
      }
    },
    toggleFavourite: function (ath) {
      if (typeof (ath.athlete_id) !== 'undefined') {
        let index = this.favourites.indexOf(ath.athlete_id)
        if (index > -1) {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Athlete remove: ' + ath.athlete_id, label: 'Loaded', value: ''})
          this.$store.dispatch('removeFavourite', ath.athlete_id)
        } else {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Athlete add: ' + ath.athlete_id, label: 'Loaded', value: ''})
          this.$store.dispatch('addFavourite', ath.athlete_id)
        }
      } else if (typeof (ath.team_id) !== 'undefined') {
        let index = this.favourites.indexOf(ath.team_id)
        if (index > -1) {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Team remove: ' + ath.team_id, label: 'Loaded', value: ''})
          this.$store.dispatch('removeFavourite', ath.team_id)
        } else {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Team add: ' + ath.team_id, label: 'Loaded', value: ''})
          this.$store.dispatch('addFavourite', ath.team_id)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/athlete/athletedetailed.vue